/* eslint-disable import/prefer-default-export */
import { RootState } from 'app/store'
import { createSelector } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { isRoleGreaterThanOrEq, getHighestRole } from 'utils/permissionUtil'
import UserRole from 'enums/UserRole'
import { getTimeZoneId } from 'enums/TimeZone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const selectIsRoleBelowAnalyst = createSelector(
  [(state: RootState) => state.pageConfig.config.user],
  (userconfig) => {
    const currentHighestRole = getHighestRole(userconfig?.userRoles ?? [])
    const equalOrAboveAnalyst = isRoleGreaterThanOrEq(currentHighestRole, UserRole.ROLE_BASIC_USER)
    return !equalOrAboveAnalyst
  }
)

export const selectUserTimeZone = createSelector(
  [(state: RootState) => state.pageConfig.config.user.timeZone],
  (timeZoneKey) => {
    const tzId = timeZoneKey ? getTimeZoneId(timeZoneKey) : getTimeZoneId()

    const utcOffset = dayjs().tz(tzId).format('Z')

    return `(GMT${utcOffset})`
  }
)
